import React, { useState } from 'react';
import { Upload, FileSpreadsheet } from 'lucide-react';
import { toast } from 'sonner';
import { useAuth } from '../../context/AuthContext';
import { inputCls, btnPrimary, btnGhost } from './MlmShell';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const MlmImportModal = ({ groups, onClose, onImported }) => {
  const { authFetch } = useAuth();
  const [file, setFile] = useState(null);
  const [group, setGroup] = useState('prospecto');
  const [tags, setTags] = useState('');
  const [preview, setPreview] = useState(null);
  const [busy, setBusy] = useState(false);

  const run = async (previewOnly) => {
    if (!file) { toast.error('Selecciona un archivo CSV o Excel'); return; }
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append('file', file); fd.append('default_group', group); fd.append('tags', tags); fd.append('preview', previewOnly ? '1' : '0');
      const res = await authFetch(`${API}/mlm/prospects/import`, { method: 'POST', body: fd });
      const json = await res.json();
      if (!res.ok) throw new Error(json.detail || 'Error al importar');
      if (previewOnly) setPreview(json);
      else { toast.success(`${json.to_import} contactos importados (${json.duplicates} duplicados omitidos)`); onImported(); onClose(); }
    } catch (err) { toast.error(err.message); } finally { setBusy(false); }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-[#062A5E]/60 p-4" onClick={onClose}>
      <div className="w-full max-w-2xl rounded-[26px] bg-white p-6" onClick={(e) => e.stopPropagation()} data-testid="mlm-import-modal">
        <p className="text-[11px] font-bold uppercase tracking-[0.3em] text-[#E2001A]">Base de datos</p>
        <h3 className="mt-1 text-xl font-black text-[#062A5E]">Importar contactos de Laura</h3>
        <p className="mt-1 text-sm text-slate-500">Excel o CSV exportado de PM, Google Contacts o WhatsApp. Detectamos nombre, email, teléfono y tipo automáticamente y omitimos duplicados.</p>
        <div className="mt-4 grid gap-3 sm:grid-cols-3">
          <label className="flex cursor-pointer items-center gap-2 rounded-xl border border-dashed border-[#0B3F8C]/40 bg-[#f1f5fb] px-3 py-2.5 text-sm text-slate-700 sm:col-span-3">
            <FileSpreadsheet className="h-4 w-4 text-[#0B3F8C]" />{file ? file.name : 'Elegir archivo (.xlsx, .csv)'}
            <input type="file" accept=".csv,.xlsx,.xls,text/csv" className="hidden" onChange={(e) => { setFile(e.target.files[0]); setPreview(null); }} data-testid="mlm-import-file" />
          </label>
          <select value={group} onChange={(e) => setGroup(e.target.value)} className={inputCls} data-testid="mlm-import-group">{groups.map((g) => <option key={g.id} value={g.id}>Grupo por defecto: {g.label}</option>)}</select>
          <input placeholder="Etiquetas para todos (coma): Francia, Evento junio" value={tags} onChange={(e) => setTags(e.target.value)} className={`${inputCls} sm:col-span-2`} data-testid="mlm-import-tags" />
        </div>
        {preview && (
          <div className="mt-4 rounded-2xl bg-[#f1f5fb] p-4 text-sm" data-testid="mlm-import-preview">
            <p className="font-bold text-[#062A5E]">{preview.total_rows} filas · {preview.to_import} nuevos · {preview.duplicates} duplicados · {preview.invalid} sin datos</p>
            <p className="mt-1 text-xs text-slate-500">Columnas: {Object.entries(preview.columns_detected).map(([k, v]) => `${k} ← ${v}`).join(' · ')}</p>
            <p className="mt-1 text-xs text-slate-500">Grupos: Clientes {preview.groups.cliente} · Socios {preview.groups.socio} · Prospectos {preview.groups.prospecto}</p>
            <ul className="mt-2 space-y-1 text-xs text-slate-700">{preview.sample.map((s, i) => <li key={i}>• {s.name} · {s.email || '—'} · {s.phone || '—'} · {s.group}</li>)}</ul>
          </div>
        )}
        <div className="mt-5 flex flex-wrap gap-2">
          <button type="button" onClick={() => run(true)} disabled={busy || !file} className={btnGhost} data-testid="mlm-import-preview-btn">Vista previa</button>
          <button type="button" onClick={() => run(false)} disabled={busy || !file || (preview && preview.to_import === 0)} className={btnPrimary} data-testid="mlm-import-confirm"><Upload className="h-4 w-4" />{busy ? 'Procesando…' : 'Importar'}</button>
          <button type="button" onClick={onClose} className={btnGhost}>Cerrar</button>
        </div>
      </div>
    </div>
  );
};
